import {Box, Stack} from "@mui/material";
import React from "react";
import {choiceSurfaceSx} from "../../runner/questions/runnerSurface";
import {QuestionEditorProps} from "./questionEditor.types";
import ScaleLabelFields from "./ScaleLabelFields";

const SCALE_VALUES = Array.from({length: 10}, (_, index) => index + 1);

const SCORE_TRACK_WIDTH = 640;
const SCORE_BOX_HEIGHT = 56;
const SCORE_GRID_COLUMNS = {xs: 'repeat(5, minmax(0, 1fr))', sm: 'repeat(10, minmax(0, 1fr))'};
const SCORE_GRID_GAP = {xs: 0.75, sm: 1};
const SCORE_FONT_SIZE = {xs: '1rem', sm: '1.125rem'};

function ScoreQuestionEditor(props: QuestionEditorProps) {
    return (
        <Stack gap={2}>
            <Box
                aria-hidden
                sx={{
                    width: '100%',
                    maxWidth: SCORE_TRACK_WIDTH,
                    display: 'grid',
                    gridTemplateColumns: SCORE_GRID_COLUMNS,
                    gap: SCORE_GRID_GAP,
                    pointerEvents: 'none',
                }}
            >
                {SCALE_VALUES.map(value => (
                    <Box
                        key={value}
                        sx={theme => ({
                            ...choiceSurfaceSx(false)(theme),
                            minWidth: 0,
                            height: SCORE_BOX_HEIGHT,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: SCORE_FONT_SIZE,
                            fontWeight: 600,
                            lineHeight: 1.25,
                            color: 'text.primary',
                        })}
                    >
                        {value}
                    </Box>
                ))}
            </Box>

            {props.scaleLabelsVisible && <ScaleLabelFields {...props}/>}
        </Stack>
    );
}

export default ScoreQuestionEditor;
